var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAcreditadas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_00000169557112922397207410000001294924168990713245_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.2 70.9",
    style: {
      enableBackground: "new 0 0 59.2 70.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.4,43.1L12.3,33c-1.8-1.8-1.8-4.8,0-6.5l0,0c1.8-1.8,4.8-1.8,6.5,0l5.7,5.7l15.7-15.7c1.8-1.8,4.8-1.8,6.5,0l0,0 c1.8,1.8,1.8,4.8,0,6.6L26.7,43.1C26.3,44.4,23.7,44.4,22.4,43.1L22.4,43.1L22.4,43.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.2,59.2H8.9c-4.9,0-8.9-4-8.9-8.9V8.9C0,4,4,0,8.9,0h41.3c4.9,0,8.9,4,8.9,8.9v41.3C59.2,55.1,55.1,59.2,50.2,59.2z  M8.9,4C6.2,4,4,6.2,4,8.9v41.3c0,2.7,2.2,4.9,4.9,4.9h41.3c2.7,0,4.9-2.2,4.9-4.9V8.9c0-2.7-2.2-4.9-4.9-4.9H8.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54,62.9L54,62.9c0,2.7-2.2,4.8-4.8,4.8H10c-2.7,0-4.8-2.2-4.8-4.8l0,0c0-0.5-0.4-0.9-0.9-0.9H2.9C2.4,62,2,62.4,2,62.9 l0,0c0,4.4,3.6,8,8,8h39.1c4.4,0,8-3.6,8-8l0,0c0-0.5-0.4-0.9-0.9-0.9h-1.3C54.4,62,54,62.4,54,62.9z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcreditadas);
export default __webpack_public_path__ + "static/media/acreditadas.7d45b00d968434cd4a73e91b1cad11f3.svg";
export { ForwardRef as ReactComponent };